import { render, staticRenderFns } from "./chairScreenProjects.vue?vue&type=template&id=75fe0230"
import script from "./chairScreenProjects.vue?vue&type=script&lang=js"
export * from "./chairScreenProjects.vue?vue&type=script&lang=js"
import style0 from "./chairScreenProjects.vue?vue&type=style&index=0&id=75fe0230&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports